import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';
type Props = {
  children: ReactNode;
};
export function Title(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      paddingY: 2,
      paddingX: 3,
      backgroundColor: "lime.tintLP2",
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "fit-content"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      color: "greens.dark",
      fontSize: 24,
      fontWeight: 500,
      lineHeight: 1.3,
      letterSpacing: "0.12px"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <Box sx={t1}><Typography component="h3" sx={t2}>{children}</Typography></Box>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}